'use strict';

var _      = require('underscore');
var $      = require('jquery');
var Core   = require('../core/core.js');

/**
 * Creates a Loading Layout
 *
 * @param {String} [options.target=body]
 * @class
 */

class Throbber extends Core {

    _defaults() {
        return {
            target: 'body',
            fields: {
                'theme': 'default'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `<div class="throbber <% if(theme == 'light'){ %>throbber--light <% } %>">
                            <div class="throbber__bounce1"></div>
                            <div class="throbber__bounce2"></div>
                            <div class="throbber__bounce3"></div>
                        </div>`;

        super.render();
    }

}
module.exports = Throbber;
